var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-empty-state',{attrs:{"title":_vm.$options.i18n.title,"description":_vm.$options.i18n.description,"svg-path":_vm.$options.EMPTY_STATE_SVG,"svg-height":null,"primary-button-link":_vm.pipelineEditorPath,"primary-button-text":_vm.$options.i18n.buttonText,"data-testid":"jobs-empty-state"}})
}
var staticRenderFns = []

export { render, staticRenderFns }